import { useCallback, useMemo, useState } from 'react'
import { Prose } from '@azoya-spa/ui'
import LegalPage from './LegalPage'
import { TexteLegal } from './TexteLegal'
import { useSiteContentState } from '../../hooks/useSiteContent'

const FALLBACK = {
  title: "Conditions générales d'utilisation",
  bodyMarkdown: 'Contenu momentanément indisponible.',
}

const LEAD =
  'Ce que vous acceptez en utilisant le site, ce que nous déposons sur votre appareil, et ce que vous pouvez refuser.'

// « Article 3 : Collecte des données » se lit « Collecte des données » dans le
// sommaire : le numéro y est déjà, en pastille corail devant le libellé.
const PREFIXE_ARTICLE = /^Article\s+\d+\s*:\s*/i

function Cgu() {
  const { data: page, status, reessayer } = useSiteContentState('legal/cgu', FALLBACK)
  const [titres, setTitres] = useState([])


  // Rien n'a jamais été chargé — ni l'API ni le cache : c'est le corps de la
  // page qui manque, pas la page. Le bandeau et le titre restent affichés.
  const indisponible = status === 'error' && page === FALLBACK

  const sommaire = useMemo(
    () =>
      titres.map((titre, rang) => ({
        id: titre.id,
        num: String(rang + 1).padStart(2, '0'),
        label: titre.text.replace(PREFIXE_ARTICLE, ''),
      })),
    [titres],
  )

  const onHeadings = useCallback((entetes) => setTitres(entetes), [])

  return (
    <LegalPage
      title={page.title}
      lead={LEAD}
      meta={sommaire.length ? `${sommaire.length} articles` : null}
      sibling={{ href: '/mentions-legales', label: 'Mentions légales' }}
      sommaire={sommaire}
      indisponible={indisponible}
      onReessayer={reessayer}
    >
      <Prose onHeadings={onHeadings}>
        <TexteLegal>{page.bodyMarkdown}</TexteLegal>
      </Prose>
    </LegalPage>
  )
}

export default Cgu
